import React, { Fragment } from 'react';
import { Typography, Button } from '@material-ui/core';


import { Currency } from 'react-frontend-utils' 
import { Patron } from '../models/Patron'

import { CommonPatronFunctions } from '../components/CommonPatronFunctions'

/**
 *  Let the Patron modify the Booking
 * 
 * The following props are required:
 *  event: the Event object that the user signed up for
 *  database: the database to use for the Event
 *  patron: the Patron object that the user signed up with
 * 
 *  cancelSignupCallback: the callback to call when the user wants to cancel the Signup
 * 
 *  optional:
 *      slaveEvents (for MultiDayEvents): the slave events in the MultiDayEvent series, used to display the dates of the other events in the series
 *  
 */
export function ManageSignupPage(props) {

        
    const event = props.event;
    const patron = props.patron;
    
    if (!patron)
        return <Typography align='center' variant="h6">This Signup does not exist.</Typography>

    const slaveTimeStyles = {
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            borderBottom: '1px solid gray', 
            borderTop: '1px solid gray',
            paddingBottom: 5,
            marginBottom: 20,
            paddingTop: 5,
            marginTop: 20,
        };


    return (
        <Fragment>
            <Typography align='center' variant="h6" style={{marginBottom: 10}}>{"Welcome Back, " + patron.patronNames[0]}</Typography>
            <Typography align='center' variant="h5" style={{fontWeight: 'bold', marginTop: 20, marginBottom: 10}}>{"You signed up for the Event \"" + event.title + "\""}</Typography>
            {CommonPatronFunctions.finalBookingSignupDateDisplay(event)}

            {props.slaveEvents ? 
                <div style={slaveTimeStyles}>
                    <Typography variant="body2" style={{fontWeight: 'bold', marginBottom: 5}}>Additional Sessions:</Typography>
                    {props.slaveEvents.map((meSlave, index) =>
                        <Fragment key={index}>
                            {CommonPatronFunctions.finalBookingSignupDateDisplay(meSlave, true)}
                        </Fragment>)
                    }
                </div>
                : 
                null
            }

            {patron.status() === Patron.Status.CONFIRMED_PAID ?
                <Typography align='center' variant="body1" style={{color: 'green'}}>{"Paid: " + Currency.round(patron.calculatedCost) + " " + patron.isoCurrency}</Typography>
                : null
            }

            <hr style={{margin: 20}}/>

     
            <div style={{display: 'flex', flexDirection: 'column', gap: 20, justifyContent: 'center', alignItems: 'center'}}>
                <Button style={{minWidth: 400, color: 'red'}} variant="outlined" onClick={props.cancelSignupCallback}>Cancel</Button> 
            </div>
            
        </Fragment>
    );
}   
